import React from "react";
import TrendCards from "../dashboard/components/Cards/TrendCards";

const FormSummaryCard = ({
  cardNumber,
  cardTitle,
  cardSubContent,
  loading,
  iconKey,
}) => {
  return (
    <div className="col-6 col-md-4 mb-4">
      <TrendCards
        iconKey={iconKey}
        cardNumber={cardNumber}
        cardTitle={cardTitle}
        cardSubContent={cardSubContent}
        loading={loading}
      />
    </div>
  );
};

export default FormSummaryCard;
